/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-nested-ternary */
import React, { useState, Fragment, useContext, useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { NestedMenuItem } from '@mummssoftware/common-ui';
import {
  isAgencyEnabled,
  isUserDoctorNurseRoleGroup,
} from '@mummssoftware/utils/utils';
import {
  ORDERS_MENU,
  IDG_MENU,
  MEDS_MENU,
  CPP_PLANS_MENU,
  CPF_PLANS_MENU,
  EA_MENU,
  CascadeMenu,
  CascadeMenuItem,
  generalMenuHospice,
  generalMenu,
  DischargeOrder,
  VERBAL_ORDERS_MENU,
} from '@mummssoftware/utils/orders';
import {
  getRefMenu,
  getOthMenu,
} from '@mummssoftware/utils/orders/orders-menus';
import OrdersMenu from '../MenuContent/OrdersMenu';
import IDGMenu from '../MenuContent/IDGMenu';
import EAMenu from '../MenuContent/EAMenu';
import MedsCppPlanMenu from '../MenuContent/MedsCppPlanMenu';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { isCascadedMenuItemAllowed } from './utils';
import {
  CLOSE_MENU,
  SET_MENU_TYPE,
  NO_ORDERS_MENU,
  PUBLISHED_NOTE_MENU,
  PCPP,
  PCPF,
  MM,
  INTRO_MENU,
  IDG,
  EA,
  Admit,
} from '../Context/constants';
import { Context } from '../../context';
import { useStyles } from '../style/style';

import defaults from '../../translations/en.json';

// publishedNoteMenu prop when this is from a published note
type TagComponentProps = {
  note: mumms.progressNotebyEntity | null;
  publishedNoteMenu?: mumms.IntroMenuType[] | null;
  saveInitialNote?: boolean;
  disabled?: boolean;
};

const TagComponent = ({
  note,
  publishedNoteMenu,
  saveInitialNote,
  disabled,
}: TagComponentProps) => {
  const classes = useStyles();
  const {
    menuType,
    dispatch,
    closeMenu,
    orderCreated,
    disOrderMap,
    isPhysicianRoleGroup,
  } = useContext(ProgressNotesContext);
  const {
    agency,
    patient,
    saveFirstNote,
    updateProgressNotes,
    updatedNote,
    refreshPatientHeader,
    currentUser,
  } = useContext(Context);

  const [anchorEl, setAnchorEl] = useState(null);

  // menu depends on Admit/Discharge , on IDG, on HOSPICE

  const hasEpisodes = patient.episodes && patient.episodes.length;
  const isHospice =
    hasEpisodes &&
    patient.episodes[patient.episodes.length - 1].programId === -1;

  const isIDGTagged =
    note &&
    note.patientprogressnoteentitydto &&
    (note.patientprogressnoteentitydto as any)[IDG];

  const isEATagged =
    note &&
    note.patientprogressnoteentitydto &&
    (note.patientprogressnoteentitydto as any)[EA];

  let introMenu: any;
  let noOrderMenu: mumms.IntroMenuType[];

  const eaMenuItems: mumms.IntroMenuType[] =
    isHospice && !isEATagged ? [EA_MENU] : [];

  if (isIDGTagged) {
    noOrderMenu = [MEDS_MENU, CPP_PLANS_MENU, CPF_PLANS_MENU, ...eaMenuItems];
  } else {
    noOrderMenu = [
      IDG_MENU,
      MEDS_MENU,
      CPP_PLANS_MENU,
      CPF_PLANS_MENU,
      ...eaMenuItems,
    ];
  }

  const cpfOrderWidgetBins: string = window.env?.cpfOrderWidgetBins as string;
  const cpfOrderWidgetBinsArr = cpfOrderWidgetBins.length
    ? cpfOrderWidgetBins.split(',')
    : [];
  const prnOrderWidgetBins: string = window.env?.prnOrderWidgetBins as string;
  const prnOrderWidgetBinsArr = prnOrderWidgetBins.length
    ? prnOrderWidgetBins.split(',')
    : [];
  const freqOrderWidgetBinsArr = cpfOrderWidgetBinsArr.concat(
    prnOrderWidgetBinsArr,
  );
  const freqOrderWidgetBins = freqOrderWidgetBinsArr.toString();
  const isFreqAgency = isAgencyEnabled(freqOrderWidgetBins, currentUser);

  // Get the base menu items
  if (patient.admissionDate) {
    if (isHospice) {
      introMenu = generalMenuHospice(isFreqAgency);
    } else {
      introMenu = generalMenu(isFreqAgency);
    }
  } else if (patient.patientPossibleActions) {
    if (patient.patientPossibleActions.includes(Admit)) {
      if (isPhysicianRoleGroup) {
        introMenu = getOthMenu(isHospice);
      } else {
        introMenu = getRefMenu(isHospice);
      }
    } else {
      introMenu = getOthMenu(isHospice);
    }
  } else {
    introMenu = getOthMenu(isHospice);
  }
  const checkRole = (item: CascadeMenuItem) => {
    const shortName = item.shortname || '';
    const isDischargeOrder = disOrderMap && disOrderMap[shortName];
    if (isDischargeOrder || item.name === VERBAL_ORDERS_MENU) {
      return isUserDoctorNurseRoleGroup(currentUser);
    }
    return true;
  };

  // filter function to remove menu items that are not enabled.
  // Since a CascadeMenuItem can include an array of CascadeMenuItem objects, we
  // can call this recursively to filter all levels of the menu.
  const filterMenuItems = (menuItems: CascadeMenuItem[]): CascadeMenuItem[] => {
    let filteredMenu: CascadeMenuItem[] = [];
    filteredMenu = menuItems.filter(
      (el: CascadeMenuItem) =>
        checkRole(el) &&
        isCascadedMenuItemAllowed(el, agency, isIDGTagged, !!isEATagged),
    );
    filteredMenu.forEach((cmi: CascadeMenuItem) => {
      if (
        !!cmi.submenu &&
        Array.isArray(cmi.submenu) &&
        cmi.submenu.length > 0
      ) {
        cmi.submenu = filterMenuItems(cmi.submenu as CascadeMenuItem[]);
      }
    });

    return filteredMenu;
  };

  // filter out the menu items that should not be displayed
  introMenu = filterMenuItems(introMenu as CascadeMenuItem[]);

  const handleChange = (event: any) => {
    // if an order has been placed => orderCreated is true
    // if an order has been placed, option should disappear from menu
    if (orderCreated) {
      dispatch({
        type: SET_MENU_TYPE,
        payload: NO_ORDERS_MENU,
      });
      setAnchorEl(event.currentTarget);
      // defaults to normal intro if saveInitialNote => opened from write a note
    } else if (saveInitialNote) {
      dispatch({
        type: SET_MENU_TYPE,
        payload: INTRO_MENU,
      });
      setAnchorEl(event.currentTarget);

      // if workflow was abandoned in the middle set the generated text free
      dispatch({
        type: CLOSE_MENU,
        payload: null,
      });
      // TODO is that necessary? means when order done and want to tag MEDS gets erased
      // dispatch({
      //   type: SET_ORDER_STATEMENT,
      //   payload: null,
      // });

      // logic for PUBLISHED_NOTE_MENU

      // this is the default logic because when close menu and set menuType to null need a timeOut and
      // may default to intro menu in published note
      // defaults reverts to PUBLISHED_NOTE_MENU if opened from published note
      // if publishedNoteMenu is not null, can be []
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  useEffect(() => {
    // @note need to refresh patient header
    // reason is PIM change does not reflect recent changes
    // saveInitialNote is the Tag Component of write a note, otherwise as many tag components as notes
    if (saveInitialNote && menuType === ORDERS_MENU) {
      refreshPatientHeader(patient.patientNumber, agency);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuType]);

  useEffect(() => {
    if (closeMenu) {
      setAnchorEl(null);
    }
  }, [closeMenu]);

  const onClose = () => {
    // * MEDS MENU
    // * CPP_PLANS_MENU
    // if updated note then refresh the list of notes and clears updatedNote
    // this is for notes that have already been published
    // need to refresh the list of notes but should not scroll to bottom
    // ! the idea is to only refresh the list of notes ONE TIME when closing menu
    // ! and not as every click on meds to avoid multiple API calls
    // ! on unmount in meds does not work.

    if (
      menuType === MEDS_MENU ||
      menuType === CPP_PLANS_MENU ||
      menuType === CPF_PLANS_MENU ||
      menuType === EA_MENU
    ) {
      if (updatedNote) {
        updateProgressNotes(patient.patientNumber, agency);
      }
    }
    // close menu
    setAnchorEl(null);
    // need a delay bc if SET_MENU_TYPE to null right away the default menu appears for a sec when closing

    // ISSUE : This causes an issue when closing published note menu from the top of a scrolling bar as it scrolls downs

    setTimeout(() => {
      dispatch({
        type: SET_MENU_TYPE,
        payload: null,
      });
    }, 100);
  };

  const setChoice = (choice: string) => async () => {
    if (saveInitialNote) {
      // open and click the menu, a note has been created, so keep this one
      // This is the first NOTE API Call
      await saveFirstNote();
    }

    let selectedChoice = choice;
    // make sure the menu doesn't close on click if there is a submenu
    if (menuType && menuType === (INTRO_MENU as any)) {
      if (choice === VERBAL_ORDERS_MENU || choice === DischargeOrder) {
        selectedChoice = INTRO_MENU;
      }
    }
    dispatch({
      type: SET_MENU_TYPE,
      payload: selectedChoice as mumms.IntroMenuType,
    });
  };

  const createMenu = (menuItems?: mumms.IntroMenuType[] | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: mumms.IntroMenuType, i: number) => (
          <MenuItem key={`choice-${i}`} onClick={setChoice(choice)}>
            {choice}
          </MenuItem>
        ))}
      </div>
    ) : (
      <div>{defaults.noMenu}</div>
    );

  const createSubMenu = (submenu: CascadeMenu) => (
    <OrdersMenu orders={submenu} saveInitialNote={saveInitialNote} />
  );

  const createCascadeMenu = (menuItems?: CascadeMenu | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: CascadeMenuItem, i: number) =>
          choice.submenu ? (
            <NestedMenuItem
              label={choice.name}
              key={`choice-${i}`}
              onClick={setChoice(choice.name)}
              parentMenuOpen={Boolean(anchorEl)}
            >
              {createSubMenu(choice.submenu)}
            </NestedMenuItem>
          ) : (
            <MenuItem
              key={`choice-${i}`}
              onClick={setChoice(choice.name)}
              disabled={choice.disabled}
            >
              {choice.name}
            </MenuItem>
          ),
        )}
      </div>
    ) : (
      <div>{defaults.noMenu}</div>
    );

  const getMenuContent = (menuchoice: string | null) => {
    switch (menuchoice) {
      case IDG_MENU:
        return <IDGMenu note={note} />;
      case EA_MENU:
        return <EAMenu note={note} />;
      case MEDS_MENU:
        return (
          <MedsCppPlanMenu
            type={MM}
            note={note}
            saveInitialNote={saveInitialNote}
          />
        );
      case CPP_PLANS_MENU:
        return (
          <MedsCppPlanMenu
            type={PCPP}
            note={note}
            saveInitialNote={saveInitialNote}
          />
        );
      case CPF_PLANS_MENU:
        return (
          <MedsCppPlanMenu
            type={PCPF}
            note={note}
            saveInitialNote={saveInitialNote}
          />
        );
      case NO_ORDERS_MENU:
        return createMenu(noOrderMenu);
      case INTRO_MENU:
        return createCascadeMenu(introMenu);
      case PUBLISHED_NOTE_MENU:
        return createMenu(publishedNoteMenu);
      // default is PUBLISHED_NOTE_MENU to avoid menu loss of anchor
      default:
        return createMenu(publishedNoteMenu);
    }
  };

  // TODO in style file
  const getClasses = (menuchoice: string | null) => {
    switch (menuchoice) {
      case IDG_MENU:
      case EA_MENU:
      case CPF_PLANS_MENU:
      case CPP_PLANS_MENU: {
        return {
          elevation8: classes.otherMenuHospice,
        };
      }
      case MEDS_MENU: {
        return {
          elevation8: classes.medsMenu,
        };
      }
      case INTRO_MENU: {
        return {
          elevation8: classes.introMenu,
        };
      }
      // case PUBLISHED_NOTE_MENU:
      // case NO_ORDERS_MENU:
      default:
        return {
          elevation8: classes.defaultMenu,
        };
    }
  };

  return (
    <Fragment>
      <IconButton onClick={handleChange} size="small" disabled={disabled}>
        <ArrowDropDownCircleIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        PaperProps={{
          classes: getClasses(menuType),
        }}
      >
        <div>{getMenuContent(menuType)}</div>
      </Menu>
    </Fragment>
  );
};

export default TagComponent;
